<app-page>
    <div class="electronics-page col-12 m-auto py-4 p-0">
        <div role="alert" *ngIf="errorMessage">
            <p-message class="plain-message" [severity]="errorMessage.severity" (onClose)="clearErrorMessage()"
                [icon]="errorMessage.icon" styleClass="mb-4 p-2" closable [ariaInjector]="[{
                    selector: '.p-message-close-button',
                    ariaLabel: 'Error message - close button',
                    role: 'button'
        }]">
                <p class="mb-2 mt-0">Error</p><span role="Error" aria-live="polite"
                    [innerHtml]="errorMessage.text"></span>
            </p-message>
        </div>
        <!-- HERO SECTION -->
        <div class="flex flex-column sm:flex-row align-items-center p-0 bg-slate-700 text-white">
            <div class="col-12 sm:col-6 lg:col-4 p-0 hero-image">
                <img src="assets/icons/cross-sell.svg" alt="cross-sell-image" />
            </div>

            <div *ngIf="contentToBeDisplayed" class="col-12 sm:col-6 lg:col-8 p-3">
                <p class="offer-text"> <i class="pi pi-bolt mr-1"></i> {{ contentToBeDisplayed.title}}</p>

                <h1>{{ contentToBeDisplayed.hint }}</h1>

                <p>
                    {{ contentToBeDisplayed.description }}
                </p>
            </div>
        </div>

        <!-- CONTENT SECTION -->
        <div class="justify-content-center bg-slate-100 content flex flex-column lg:gap-4 md:flex-row px-5 py-6">

            <!-- LEFT -->
            <div class="col-12 md:col-6 lg:col-5">
                <h1 class="m-0 mb-2">{{content.content.title}}</h1>

                <p class="text-slate-700">
                    {{content.content.description}}
                </p>

                <h3>{{content.content.highlightsTitle}}</h3>

                <ul>
                    <li *ngFor="let feature of content.content.features" class="mb-2 text-slate-700">
                        {{ feature }}
                    </li>
                </ul>
            </div>

            <!-- RIGHT CARD -->
            <div class="col-12 md:col-6 lg:col-5">
                <div *ngIf="isSpecialMemberOfferFormUrl" id="special-member-offer-form">
                    <app-special-member-offer-form></app-special-member-offer-form>
                </div>
                <p-card *ngIf="contentToBeDisplayed && !isSpecialMemberOfferFormUrl">
                    <h3 class="m-0 text-slate-950">{{ content.contactCard.title }}</h3>

                    <p class="text-slate-950">{{ content.contactCard.description }}</p>

                    <p-button severity="primary" data-auto-id="cross-sell-call-me-button" [rounded]="true"
                        (click)="callPhone(contentToBeDisplayed.phone)" class="w-full"
                        styleClass="text-base w-full white-space-nowrap shadow-button mb-2"
                        label="{{contentToBeDisplayed.phone | phone}}">
                        <i class="pi pi-phone mr-2"></i>
                    </p-button>

                    <div class="text-slate-950 text-sm" [innerHTML]="contentToBeDisplayed.hoursOfOperation"></div>
                </p-card>

                <p-card styleClass="mt-3" *ngIf="contractData && contentToBeDisplayed && !isSpecialMemberOfferFormUrl">
                    <p class="text-slate-950 m-0">
                        {{ content.supportCard.text }} <a href="https://www.cinchhomeservices.com/contact-us"
                            data-auto-id="cinch-homeservice-contact"
                            class="underline text-blue-700 text-base line-height-3 font-normal">{{
                            content.supportCard.linkText }}</a> or call {{
                        contractData.baseContract.customerServicePhoneNumber | phone }}.
                    </p>
                </p-card>
            </div>

        </div>

        <!-- HOW IT WORKS -->
        <div class="text-center bg-white md:p-8 px-4 py-5">
            <h2>{{ content.stepsSection.title }}</h2>
            <p class="sub">{{ content.stepsSection.subtitle }}</p>

            <div class="flex flex-column md:flex-row align-items-center mt-5 justify-content-center">
                <div *ngFor="let step of content.stepsSection.steps" class="col-12 md:col-4 text-center px-5">
                    <div class="step-circle">{{ step.step }}</div>
                    <h4>{{ step.title }}</h4>
                    <p>{{ step.description }}</p>
                </div>
            </div>
        </div>

        <!-- CTA -->
        <div *ngIf="contentToBeDisplayed && contractData" class="bg-slate-700 text-center py-6 px-5 text-white">
            <div *ngIf="isSpecialMemberOfferFormUrl">
                <h2 class="m-0">Ready to protect your home electronics?</h2>
                <p class="my-4">Help protect the electronics you use every day with coverage starting at $14.99 per
                    month. †</p>
                <p-button severity="primary" data-auto-id="cross-sell-call-me-button" [rounded]="true"
                    (click)="scrollToForm()" class="w-full"
                    styleClass="text-base w-full sm:w-10 md:w-8 lg:w-5 white-space-nowrap shadow-button mb-2"
                    label="Get Started">
                </p-button>
            </div>
            <div *ngIf="!isSpecialMemberOfferFormUrl">
                <h2 class="m-0">{{ content.cta.title }}</h2>
                <p class="my-4">{{ content.cta.description }}</p>

                <p-button severity="primary" data-auto-id="cross-sell-call-me-button" [rounded]="true"
                    (click)="callPhone(contentToBeDisplayed.phone)" class="w-full"
                    styleClass="text-base w-full sm:w-10 md:w-8 lg:w-5 white-space-nowrap shadow-button mb-2"
                    label="{{contentToBeDisplayed.phone | phone}}">
                    <i class="pi pi-phone mr-2"></i>
                </p-button>

                <div class="text-white text-sm text-center" [innerHTML]="contentToBeDisplayed.hoursOfOperation"></div>
                <p class="m-0 mt-4">{{ content.cta.subText }} {{contractData.baseContract.customerServicePhoneNumber |
                    phone}}</p>
            </div>
        </div>

        <!-- TnC -->
        <div class="pt-6 px-5 text-slate-600">
            <p class="m-0">{{content.tnc.title}}</p>
            <p class="m-0 mt-5">{{ content.tnc.description }}</p>
        </div>

    </div>
</app-page>